




import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {PredefinedNoticeTypes} from '@/utils/notices'
import SimpleList from '@/components/SimpleList.vue'
import NoticeTypeRow from './NoticeTypeRow.vue'

@Component<NoticeTypePicker>({
    components: {
        SimpleList
    }
})
export default class NoticeTypePicker extends Vue {
    @Prop({type: String}) public selected ?: string

    protected get rows() {
        return PredefinedNoticeTypes.filter((notice) => notice.isComposing).map((noticeType) => this.noticeTypeRow(noticeType))
    }

    private noticeTypeRow(noticeType) {
        return {
            id: noticeType.name,
            onClick: () => {
                this.$emit('select', noticeType.name)
            },
            rowComponent: {
                component: NoticeTypeRow,
                props: {
                    noticeType,
                    selected: this.selected === noticeType.name
                }
            }
        }
    }
}
